import { Routes, Route } from 'react-router-dom';
import { MainLayout } from '@/components/layout/MainLayout';
import { HomePage } from '@/pages/HomePage';
import { CatalogPage } from '@/pages/CatalogPage';
import {
  ProductDetailPage,
  KitsPage,
  KitDetailPage,
} from '@/pages/ProductPages';
import { CheckoutPage } from '@/pages/CheckoutPage';
import { LoginPage, CuentaPage, PedidoDetallePage } from '@/pages/AccountPages';
import { RecuperarClavePage } from '@/pages/ClientAccessPages';
import { Navigate } from 'react-router-dom';

export default function App() {
  return (
    <Routes>
      <Route element={<MainLayout />}>
        <Route index element={<HomePage />} />
        <Route path="catalogo" element={<CatalogPage />} />
        <Route path="producto/:id" element={<ProductDetailPage />} />
        <Route path="kits" element={<KitsPage />} />
        <Route path="kits/:slug" element={<KitDetailPage />} />
        <Route path="checkout" element={<CheckoutPage />} />
        <Route path="ingresar" element={<LoginPage />} />
        <Route path="activar-cuenta" element={<Navigate to="/recuperar" replace />} />
        <Route path="recuperar" element={<RecuperarClavePage />} />
        <Route path="cuenta" element={<CuentaPage />} />
        <Route path="cuenta/pedidos/:folio" element={<PedidoDetallePage />} />
      </Route>
    </Routes>
  );
}
